import React from "react";

export const Image = ({ title, largeImage, smallImage }) => {
  if (!smallImage) {
    return (
      <div className="portfolio-item">
        <div className="portfolio-placeholder">
          <span>{title}</span>
        </div>
      </div>
    );
  }
  return (
    <div className="portfolio-item">
      <img src={smallImage} className="img-responsive" alt={title} />
    </div>
  );
};
